import { cn } from '@/lib/utils'
import { motion } from 'motion/react'
import { ReactNode } from 'react'

export function LandingSection({
  id,
  eyebrow,
  title,
  description,
  className,
  children,
}: {
  id?: string
  eyebrow?: string
  title?: string
  description?: string
  className?: string
  children: ReactNode
}) {
  return (
    <section id={id} className={cn('scroll-mt-8 px-6 py-20', className)}>
      <div className="mx-auto max-w-6xl">
        {(eyebrow || title || description) && (
          <motion.header
            className="mb-12 max-w-3xl"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.45 }}
          >
            {eyebrow && (
              <p className="mb-3 text-xs font-medium uppercase tracking-[0.18em] text-muted-foreground">{eyebrow}</p>
            )}
            {title && <h2 className="text-3xl font-semibold tracking-tight text-foreground">{title}</h2>}
            {description && <p className="mt-3 text-base leading-relaxed text-muted-foreground">{description}</p>}
          </motion.header>
        )}
        {children}
      </div>
    </section>
  )
}
